import { FC } from "react";
import { Wifi, Wifi2Bar, WifiOff } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { gameState } from "@/services/gameState";
import { ConnectionStatus } from "@/models/ticker";

const HeaderConnectionIndicator: FC = () => {
  const connectionStatus = gameState("connectionStatus");
  return (
    <Tooltip
      title={connectionStatusTitle[connectionStatus]}
      sx={{ padding: "8px" }}
    >
      {connectionStatus === "lost" ? (
        <WifiOff color={"error"} />
      ) : connectionStatus === "loosing" ? (
        <Wifi2Bar color={"success"} />
      ) : (
        <Wifi color={"success"} />
      )}
    </Tooltip>
  );
};

const connectionStatusTitle: { [key in ConnectionStatus]: string } = {
  connected: "Mit Live-Ticker verbunden",
  loosing: "Letzte Nachricht von Live-Ticker ist schon etwas her",
  lost: "Nicht mit Ticker verbunden",
  paused: "Verbindung wird wiederhergestellt",
};

export default HeaderConnectionIndicator;
